import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  padding-top: 15px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
